import { authApi, createParams } from './index';

export const getUsers = async (request) => {
	try {
		const params = createParams(request);
		const { data } = await authApi.get('/portal/collection/name/face-users', {
			params,
		});

		return data;
	} catch (error) {
		console.error(error);
	}
};

export const getProfiles = async ({ profiles: _profiles }) => {
	try {
		let profileData = [];
		const promises = _profiles?.map(async (_profile) => {
			const { data } = await authApi.get(
				'/portal/profile/id/face-users?id=' + _profile?.id,
			);
			if (data?.length) {
				profileData = [...profileData, ...data];
			}
		});

		const results = await Promise.all(promises);
		return profileData;
	} catch (error) {
		console.error(error);
	}
};

export const getUsersParent = async (parentId) => {
	try {
		const { data } = await authApi
			.get(`/portal/collection/all/faceusers/${parentId}`)
			.catch((error) => {
				return false;
			});

		return data;
	} catch (error) {
		console.error(error);
		return false;
	}
};

export const createUser = async (request) => {
	try {
		const { data } = await authApi.post(
			'/portal/collection/face-users',
			request,
		);

		return data;
	} catch (error) {
		console.error(error);
		return false;
	}
};

export const updateUser = async (request) => {
	try {
		const { data } = await authApi.patch(
			'/portal/collection/face-users',
			request,
		);

		return data;
	} catch (error) {
		console.error(error);
		return false;
	}
};

export const deleteUser = async (request) => {
	try {
		const { data } = await authApi.delete('/portal/collection/face-users', {
			data: request,
		});

		// console.log('getUserFace result', data);
		return data;
	} catch (error) {
		console.error(error);
		return false;
	}
};
